// Update dashboard
import React from 'react';
import styles from '../css/updatedReports.module.css';
import { useEffect, useState } from 'react';
import {
  fetchTicketIssuedCount,
  fetchCheckOutsCount,
  fetchCheckOutsCountThisHour,
  fetchCheckInsCountThisHour,
  fetchAvgStayDuration,
  fetchOccupancyData,
  fetchManualCheckOutsCount,
  countUnCheckedInTickets,
  compareTicketsIssuedTodayToYesterday,
  compareCheckOutsTodayToYesterday,
  compareOmittedTicketsTodayToYesterday,
  compareManualTicketsTodayToYesterday,
  compareTodayIssuedTktsToSDLW,
  compareTodayCheckOutsToSDLW,
} from '../helpers/databaseAPI';
import { getPendingCheckouts } from '../helpers/databaseFiles';
import { serverURL } from '../helpers/dataServerURL';
import { HiRefresh } from 'react-icons/hi';

function UpdatedDash() {
  const loginURL = serverURL.server.url;

  const [ticketIssuedCount, setTicketIssuedCount] = useState(0);
  const [checkOutsCount, setCheckOutsCount] = useState(0);
  const [checkOutsCountThisHour, setCheckOutsCountThisHour] = useState(0);
  const [checkInsCountThisHour, setCheckInsCountThisHour] = useState(0);
  const [avgStayDuration, setAvgStayDuration] = useState({ hours: 0, minutes: 0 });
  const [manualCheckOutsCount, setManualCheckOutsCount] = useState(0);
  const [pendingCheckOuts, setPendingCheckOuts] = useState(null);
  const [omittedTicketsCount, setOmittedTicketsCount] = useState(0);
  const [occupancyData, setOccupancyData] = useState(null);
  const [tktsIssuedDiff, setTktsIssuedDiff] = useState(null);
  const [issuedTktsSDLW_Diff, setIssuedTKtsSDLW_Diff] = useState(null);
  const [checkOutsDiff, setCheckOutsDiff] = useState(null);
  const [checkOutsSDLW_Diff, setCheckOutsSDLW_Diff] = useState(null);
  const [omittedTktsDiff, setOmittedTktsDiff] = useState(null);
  const [manualTktsDiff, setManualTktsDiff] = useState(null);
  const [showText, setShowText] = useState(false);

  useEffect(() => {
    async function populateDashCards() {
      setTicketIssuedCount((await fetchTicketIssuedCount(loginURL)) || 0);
      setCheckOutsCount(await fetchCheckOutsCount(loginURL));
      setCheckOutsCountThisHour((await fetchCheckOutsCountThisHour(loginURL)) || 0);
      setCheckInsCountThisHour(fetchCheckInsCountThisHour(loginURL) || 0);
      setAvgStayDuration(await fetchAvgStayDuration(loginURL));
      setManualCheckOutsCount((await fetchManualCheckOutsCount(loginURL)) || 0);
      setPendingCheckOuts((await getPendingCheckouts(loginURL)) || 0);
      setOmittedTicketsCount((await countUnCheckedInTickets(loginURL)) || 0);
      setOccupancyData((await fetchOccupancyData(loginURL)) || 0);
      setTktsIssuedDiff((await compareTicketsIssuedTodayToYesterday(loginURL)) || 0);
      setCheckOutsDiff((await compareCheckOutsTodayToYesterday(loginURL)) || 0);
      setOmittedTktsDiff((await compareOmittedTicketsTodayToYesterday(loginURL)) || 0);
      setManualTktsDiff((await compareManualTicketsTodayToYesterday(loginURL)) || 0);
      setIssuedTKtsSDLW_Diff((await compareTodayIssuedTktsToSDLW(loginURL)) || 0);
      setCheckOutsSDLW_Diff((await compareTodayCheckOutsToSDLW(loginURL)) || 0);
    }
    populateDashCards();
  }, []);

  return (
    <div className={styles.content}>
      <div
        className={styles.contentHeader}
        onMouseOver={() => {
          setShowText(true);
        }}
        onMouseOut={() => setShowText(false)}
      >
        <h1>Activities Dashboard</h1>
        <button
          // title is used as a tooltip. It is however cannot be styled and there is latency
          title="Refresh"
          className={styles.headerBtn}
          onClick={() => {
            window.location.reload();
          }}
        >
          <HiRefresh size={24} />
        </button>
        {/* {<p className={styles.tooltip}>Refresh</p>} */}
        {/* The below method to show a tooltip is preferred because it can be styled 
        and the text appears immediately and mouse hover  */}
        {showText && (
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '275px',
              transform: 'translateX(-50%)',
              background: 'black',
              color: 'white',
              padding: '5px 8px',
              borderRadius: '4px',
              marginTop: '0px',
              fontSize: '12px',
            }}
          >
            Refresh
          </div>
        )}
      </div>

      <div className={styles.statsRow}>
        <div className={styles.statCard}>
          <div className={styles.statLabel}>Tickets Issued</div>
          <div className={styles.statValue}>{ticketIssuedCount}</div>
          <div className={styles.statChangeUp}>
            {tktsIssuedDiff < 0 ? '↓' : tktsIssuedDiff === 0 ? '→' : '↑'} {tktsIssuedDiff || 0} vs yesterday |{' '}
            {issuedTktsSDLW_Diff > 0 ? '↑' : issuedTktsSDLW_Diff === 0 ? '→' : '↓'} {issuedTktsSDLW_Diff || 0} vs
            Same Day Last Week
          </div>
          <div
            className={styles.statBar}
            style={{ background: 'linear-gradient(90deg,var(--accent),transparent)' }}
          ></div>
        </div>
        <div className={styles.statCard}>
          <div className={styles.statLabel}>Pending Check Outs</div>
          <div className={styles.statValue}>{pendingCheckOuts || 0}</div>
          <div className={styles.statChangeUp}>No comparison data available</div>
          <div
            className={styles.statBar}
            style={{ background: 'linear-gradient(90deg,var(--accent2),transparent)' }}
          ></div>
        </div>
        <div className={styles.statCard}>
          <div className={styles.statLabel}>Tickets Exited</div>
          <div className={styles.statValue}>{checkOutsCount || 0}</div>
          <div className={styles.statChangeUp}>
            {checkOutsDiff < 0 ? '↓' : checkOutsDiff === 0 ? '→' : '↑'} {checkOutsDiff || 0} vs yesterday |{' '}
            {checkOutsSDLW_Diff > 0 ? '↑' : checkOutsSDLW_Diff === 0 ? '→' : '↓'} {checkOutsSDLW_Diff || 0} vs Same
            Day Last Week
          </div>
          <div
            className={styles.statBar}
            style={{ background: 'linear-gradient(90deg,var(--accent3),transparent)' }}
          ></div>
        </div>
        <div className={styles.statCard}>
          <div className={styles.statLabel}>Current Occupancy</div>
          <div className={styles.statValue}>{occupancyData || 0}</div>
          <div className={styles.statChangeUp}>No comparison data available</div>
          <div
            className={styles.statBar}
            style={{ background: 'linear-gradient(90deg,var(--accent4),transparent)' }}
          ></div>
        </div>
        <div className={styles.statCard}>
          <div className={styles.statLabel}>Average Stay</div>
          <div className={styles.statValue}>
            {avgStayDuration.hours} Hrs:{avgStayDuration.minutes} Min
          </div>
          <div className={styles.statChangeUp}>No comparison data available</div>
          <div
            className={styles.statBar}
            style={{ background: 'linear-gradient(90deg,var(--accent),transparent)' }}
          ></div>
        </div>
        <div className={styles.statCard}>
          <div className={styles.statLabel}>
            Card Entered Between{' '}
            {new Date().getHours() > 12
              ? new Date().getHours() -
                12 +
                `P- 
                  ${new Date().getHours() - 12}:59P`
              : new Date().getHours() === 12
                ? `12P-12:59P`
                : `${new Date().getHours()}:00A - ${new Date().getHours()}:59A`}
          </div>
          <div className={styles.statValue}>{checkInsCountThisHour}</div>
          <div className={styles.statChangeUp}>No comparison data available</div>
          <div
            className={styles.statBar}
            style={{ background: 'linear-gradient(90deg,var(--accent2),transparent)' }}
          ></div>
        </div>
        <div className={styles.statCard}>
          <div className={styles.statLabel}>
            Cars Exited Between{' '}
            {new Date().getHours() > 12
              ? new Date().getHours() -
                12 +
                `P- 
                  ${new Date().getHours() - 12}:59P`
              : new Date().getHours() === 12
                ? `12P-12:59P`
                : `${new Date().getHours()}:00A - ${new Date().getHours()}:59A`}
          </div>
          <div className={styles.statValue}>{checkOutsCountThisHour}</div>
          <div className={styles.statChangeUp}>No comparison data available</div>
          <div
            className={styles.statBar}
            style={{ background: 'linear-gradient(90deg,var(--accent3),transparent)' }}
          ></div>
        </div>
        <div className={styles.statCard}>
          <div className={styles.statLabel}>Manually Closed Tickets</div>
          <div className={styles.statValue}>{manualCheckOutsCount}</div>
          <div className={styles.statChangeUp}>
            {manualTktsDiff > 0 ? '↑' : manualTktsDiff === 0 ? '→' : '↓'} {manualTktsDiff || 0} vs yesterday
          </div>
          <div
            className={styles.statBar}
            style={{ background: 'linear-gradient(90deg,var(--accent4),transparent)' }}
          ></div>
        </div>
        <div className={styles.statCard}>
          <div className={styles.statLabel}>Tickets Not Scanned In</div>
          <div className={styles.statValue}>{omittedTicketsCount}</div>
          <div className={styles.statChangeUp}>
            {omittedTktsDiff > 0 ? '↑' : omittedTktsDiff === 0 ? '→' : '↓'} {omittedTktsDiff} vs yesterday
          </div>
          <div
            className={styles.statBar}
            style={{ background: 'linear-gradient(90deg,var(--accent),transparent)' }}
          ></div>
        </div>
      </div>
    </div>
  );
}

export default UpdatedDash;
